import { Table } from "../../../../_helpers/Table";
import { useNavigate, useOutletContext } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getCounters } from "../../../../_api/Counter";
import { Loader } from "../../../../_helpers/components/Forms/Loader";
import { Button } from "../../../../_helpers/components/Button";

const Counters = () => {
    const navigate = useNavigate();
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COUNTERS"]["features"];

    const [counters, setCounters] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const loadCounters = async () => {
        await getCounters().then((resp) => {
            const res = resp.data.map((res) => {
                return {
                    row: [
                        res.name,
                        new Date(res.created_at).toLocaleDateString(),
                    ],
                    data: res,
                };
            });
            setCounters(res);
            setIsLoading(false);
        });
    };

    const rowClick = (value) => {
        navigate(`/company/counter/${value.id}`);
    };

    useEffect(() => {
        loadCounters();
    }, []);

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">
                                Compteurs
                            </h1>
                            <p className="mt-2 text-sm text-gray-600">
                                Gérez les compteurs de votre entreprise
                            </p>
                        </div>
                        {features_right['add_counter'] && (
                            <Button
                                action={() => navigate("/company/counter/create")}
                                name={"Ajouter un compteur"}
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {isLoading ? (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex items-center justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary"></div>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                        <div className="p-6">
                            <Table 
                                headers={["Nom", "Date de création"]}
                                rows={counters} 
                                onClick={rowClick} 
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Counters;
